module.exports = __webpack_public_path__ + "img/logo.64418808.png";